import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Badge, Typography, Avatar, Button, Tooltip, FloatButton, message, Spin, Col, Row } from 'antd';
import { CalendarOutlined, UserOutlined, EllipsisOutlined, MessageOutlined, LikeOutlined, PlusOutlined } from '@ant-design/icons';
import AddEstateModal from './addestate';
import EstateCard from './estatecard';
import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../store/GlobalContext';
import { fetchEstates } from './estateService';
import { Estate } from '../../types';

const { Text } = Typography;

const EstateSection = styled.div`
`;

const SectionTitle = styled.h3`
  font-size: 1rem;
  font-weight: bold;
  color: #333;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;


const EstateHeader = styled.div`
  display: flex;
  align-items: left;
  justify-content: space-between;
`;

const EstateHeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
}`


const EstateTitle = styled(Text)`
  font-size: 1rem;
  font-weight: 500;
`;

const EstateBadges = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const StyledBadge = styled(Badge)`
  font-size: 0.75rem;
  font-weight: bold;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;

  &.high-priority {
    background: #d946ef;
    color: #fff;
  }

  &.low-priority {
    background: #2dd4bf;
    color: #fff;
  }

  &.time-tag {
    background: #60a5fa;
    color: #fff;
  }

  &.shared {
    background: #cbd5e1;
    color: #333;
  }
`;


const LeftDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const ActionIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #888888;

  & > span {
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }
`;

const OptionsButton = styled(Button)`
  border: none;
  background: transparent;
  color: #888888;

  &:hover {
    color: #333;
  }
`;

const EstateList = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [estates, setEstates] = useState<Estate[]>([]);
  const [loading, setLoading] = useState(true);
  const { auth } = useGlobalContext(); // Access global context to get the token
  const navigate = useNavigate();

  useEffect(() => {
    const loadEstates = async () => {
      try {
        const fetchedEstates = await fetchEstates();
          setEstates(fetchedEstates);
      } catch (error) {
        message.error("Failed to load estates");
      } finally {
        setLoading(false);
      }
    };

    loadEstates();
  }, [auth.accessToken]);

  const handleCardClick = (estateId: string) => {
    navigate(`/estate/${estateId}`);
  };

  const handleAddEstate = (values: any) => {
    setIsModalVisible(false);
  };
  
  return (
    <div>
      <Row gutter={16} style={{ marginTop: '24px' }}>
        {/* Recent Cashflow Transactions */}
        <Col span={16}>
      <EstateSection>
        <SectionTitle>
          Active Estates <Badge count={estates.length} style={{ backgroundColor: '#f3f4f6', color: '#333' }} />
        </SectionTitle>
        {loading ? (
          <Spin tip="Loading estates..." />
        ) : (
          estates.map((estate) => (
            <EstateCard
              key={estate.id}
              onClick={() => handleCardClick(estate.uuid)}
              title={estate.estateName}
              badges={[
                // { label: 'High Priority', className: 'high-priority' },
                // { label: '15 min', className: 'time-tag' },
              ]}
              dueDate=""
              likes={17} // Replace with actual data if available
              messages={6} // Replace with actual data if available
            />
          ))
        )}
      </EstateSection>

      <FloatButton tooltip={<div>Add Estate</div>} icon={<PlusOutlined />} onClick={() => setIsModalVisible(true)} />

      <AddEstateModal
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onSubmit={handleAddEstate}
      />
      </Col>
      </Row>
    </div>
  );
};

export default EstateList;
